// Shared by the individual-order action and the saved-list popup so their status
// gates stay identical. List-wide finished checks below still protect siblings.
const RFQ_CANCEL_BLOCKED_STATUSES = new Set([
  "SENT", "REJECTED", "TRADED", "EXPIRED", "MANUAL_TAKE_OVER",
  "MANUAL_TRADED", "CANCELED", "CANCELED_ACKED", "PARTIALLY FILLED", "REPLACED",
]);

export const isRfqCancelBlocked = (status) =>
  RFQ_CANCEL_BLOCKED_STATUSES.has(String(status || "").toUpperCase());

/**
 * Bond statuses a List RFQ cancel will NOT touch, because that bond has already finished.
 *
 * Mirrors ListRfqRules.TERMINAL_STATUSES in the backend, which is what actually decides -
 * OrdersCommandHandler.handleCancelListOrderCommand skips these rows and refuses the request
 * outright when none are live. This copy exists only so the UI can say so BEFORE the trader
 * clicks. If the two ever disagree, the server wins; this only ever affects what is displayed.
 */
export const LIST_FINISHED_STATUSES = new Set([
  "TRADED",
  "PARTIALLY_FILLED",
  "MANUAL_TRADED",
  "MANUAL_PARTIALLY_TRADED",
  "REJECTED",
  "EXPIRED",
  "DUE_IN_TIME_OVER",
  "CANCELED_ACKED",
  "MANUAL_TAKE_OVER",
]);

export const isFinishedListItem = (status) =>
  LIST_FINISHED_STATUSES.has(String(status || "").trim().toUpperCase());

// Naming is allowed while at least one RFQ is still live, including while a
// cancel/amend is pending. A missing status does not establish eligibility.
export const isListNameEditEligible = (status) => {
  const normalized = String(status || '').trim().toUpperCase().replace(/\s+/g, '_');
  return normalized !== '' && !LIST_FINISHED_STATUSES.has(normalized);
};

/** Enable list cancellation when any bond passes the individual cancel and finished-status gates. */
export const hasCancellableListItem = (items = []) =>
  items.some((item) => item.status && !isRfqCancelBlocked(item.status) && !isFinishedListItem(item.status));
